(function () {
  function updateCustomizeUrl(link) {
    var baseUrl = link.dataset.customizeUrl;
    if (!baseUrl) return;

    var form = link.closest('form');
    var variantInput = form && form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('variant', variantInput.value);
    link.href = url.pathname + url.search;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-product-customize-button]');
    if (link) updateCustomizeUrl(link);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[name="id"]')) return;

    var form = event.target.closest('form');
    var link = form && form.querySelector('[data-product-customize-button]');
    if (link) updateCustomizeUrl(link);
  });
})();
